module.exports = __webpack_public_path__ + "img/yibiao.bc89a61d.png";